var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1444_2144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 9.5C8.10998 9.5 7.23995 9.23608 6.49993 8.74162C5.75991 8.24715 5.18314 7.54434 4.84254 6.72208C4.50195 5.89981 4.41283 4.99501 4.58647 4.1221C4.7601 3.24918 5.18868 2.44736 5.81802 1.81802C6.44736 1.18869 7.24918 0.760102 8.12209 0.586468C8.99501 0.412835 9.89981 0.50195 10.7221 0.842544C11.5443 1.18314 12.2471 1.75991 12.7416 2.49994C13.2361 3.23996 13.5 4.10999 13.5 5C13.4988 6.19311 13.0243 7.33701 12.1807 8.18067C11.337 9.02432 10.1931 9.49881 9 9.5ZM9 2C8.40666 2 7.82664 2.17595 7.33329 2.50559C6.83994 2.83524 6.45542 3.30377 6.22836 3.85195C6.0013 4.40013 5.94189 5.00333 6.05764 5.58527C6.1734 6.16722 6.45912 6.70177 6.87868 7.12132C7.29824 7.54088 7.83279 7.8266 8.41473 7.94236C8.99667 8.05811 9.59987 7.9987 10.1481 7.77164C10.6962 7.54458 11.1648 7.16006 11.4944 6.66671C11.8241 6.17337 12 5.59335 12 5C12 4.20435 11.6839 3.44129 11.1213 2.87868C10.5587 2.31607 9.79565 2 9 2Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11C10.7896 11.002 12.5053 11.7138 13.7708 12.9792C15.0362 14.2447 15.748 15.9604 15.75 17.75C15.75 17.9489 15.671 18.1397 15.5303 18.2803C15.3897 18.421 15.1989 18.5 15 18.5C14.8011 18.5 14.6103 18.421 14.4697 18.2803C14.329 18.1397 14.25 17.9489 14.25 17.75C14.25 16.3576 13.6969 15.0223 12.7123 14.0377C11.7277 13.0531 10.3924 12.5 9 12.5C7.60761 12.5 6.27226 13.0531 5.28769 14.0377C4.30312 15.0223 3.75 16.3576 3.75 17.75C3.75 17.9489 3.67098 18.1397 3.53033 18.2803C3.38968 18.421 3.19891 18.5 3 18.5C2.80109 18.5 2.61032 18.421 2.46967 18.2803C2.32902 18.1397 2.25 17.9489 2.25 17.75C2.25199 15.9604 2.96378 14.2447 4.22922 12.9792C5.49466 11.7138 7.2104 11.002 9 11Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1444_2144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(-1 0 0 1 18 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.326b196af7a4ffbda1b53a30ebeb79b9.svg";
export { ForwardRef as ReactComponent };